<template>
  <div class="app-container">
    <!-- 查询表单 -->
    <el-card class="box-card" shadow="never">
      <div slot="header" class="clearfix">
        <span>查询条件</span>
      </div>
      <el-form :inline="true" :model="queryParams" class="demo-form-inline">
        <el-form-item label="单位名称">
          <el-input
            v-model="queryParams.companyName"
            placeholder="请输入单位名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="兑换人">
          <el-input
            v-model="queryParams.userName"
            placeholder="请输入兑换人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="queryParams.Phone"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="primary" @click="exportExcel">导出</el-button>
          <el-button type="primary" @click="exportTemplate">模板下载</el-button>
          <el-button type="success" @click="importTemplateExcel">
            导入生成
          </el-button>
          <el-button type="primary" @click="exportCardHolderRealExcel">
            导出剩余情况信息列表
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 卡片列表 -->
    <el-card class="box-card mt20" shadow="never">
      <div slot="header" class="clearfix">
        <span>工会卡列表</span>
      </div>

      <el-table :data="cardList" v-loading="loading" style="width: 100%">
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column
          prop="CompanyName"
          label="单位名称"
          width="180"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="validTime"
          label="有效时间"
          width="220"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ formatDateTime(scope.row.StartTime) }} --
            {{ formatDateTime(scope.row.EndTime) }}
          </template>
        </el-table-column>
        <el-table-column
          prop="SumPrice"
          label="金额(元)"
          show-overflow-tooltip
          width="100"
        ></el-table-column>
        <el-table-column
          prop="RemaiPrice"
          label="余额(元)"
          show-overflow-tooltip
          width="100"
        ></el-table-column>
        <el-table-column
          prop="isRedeemed"
          label="是否已兑换"
          width="100"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.Status == 1 ? 'success' : 'info'">
              {{ scope.row.Status == 1 ? "已兑换" : "未兑换" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="UserName"
          label="兑换人"
          width="100"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="TelPhone"
          label="手机号"
          width="150"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="兑换微信用户" width="150" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.WxUserInfo ? scope.row.WxUserInfo.Name : "" }}
          </template>
        </el-table-column>
        <el-table-column
          prop="Code"
          label="卡号"
          width="300"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="EnterCompanyName"
          label="录入公司"
          show-overflow-tooltip
          width="100"
        ></el-table-column>
        <el-table-column
          prop="EnterPersonName"
          label="录入人员"
          show-overflow-tooltip
          width="100"
        ></el-table-column>
        <el-table-column label="操作" width="200" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="info"
              size="mini"
              @click="handleTurnOff(scope.row)"
              v-if="scope.row.Status == 1"
            >
              停用
            </el-button>
            <el-button
              type="danger"
              size="mini"
              @click="handleDel(scope.row)"
              v-else
            >
              删除
            </el-button>
            <el-button
              type="primary"
              size="mini"
              @click="sendToSmsMsg(scope.row)"
              :disabled="scope.row.TelPhone && scope.row.Status == 1"
            >
              兑换提醒
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        class="mt20"
      >
      </el-pagination>
    </el-card>

    <!-- 新增工会卡弹窗 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <el-form
        ref="cardForm"
        :model="formData"
        :rules="formRules"
        label-width="100px"
        class="form-container"
      >
        <el-form-item label="单位名称" prop="unitName">
          <el-input
            v-model="formData.unitName"
            placeholder="请输入单位名称"
            class="form-input"
          ></el-input>
        </el-form-item>
        <el-form-item label="人数" prop="personCount">
          <el-input-number
            v-model="formData.personCount"
            :min="1"
            placeholder="请输入人数"
            class="form-input"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="有效期开始" prop="startTime">
          <el-date-picker
            v-model="formData.startTime"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="form-input"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="有效期结束" prop="endTime">
          <el-date-picker
            v-model="formData.endTime"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            class="form-input"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="金额" prop="amount">
          <el-input-number
            v-model="formData.amount"
            :min="0"
            :precision="2"
            :step="100"
            placeholder="请输入金额"
            class="form-input"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="submitLoading" @click="submitForm"
          >确 定</el-button
        >
      </div>
    </el-dialog>

    <!-- 导入Excel弹窗 -->
    <el-dialog
      title="导入Excel生成工会卡"
      :visible.sync="importDialogVisible"
      width="500px"
    >
      <div class="upload-container">
        <el-upload
          class="upload-demo"
          drag
          action="#"
          :auto-upload="false"
          :on-change="handleFileChange"
          :on-remove="handleFileRemove"
          :before-upload="beforeUpload"
          :file-list="fileList"
          :limit="1"
          accept=".xlsx,.xls"
          ref="upload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将Excel文件拖到此处，或<em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xlsx/xls文件，且不超过10MB
          </div>
        </el-upload>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">取 消</el-button>
        <el-button type="primary" :loading="importLoading" @click="submitImport"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetUnionCardList,
  PostBatchBuildCard,
  DeleteCardHolder,
  PostExportCardHolderExcel,
  PostImportCardHolderExcel,
  PostExportCardHolderRealExcel,
  GetSendMessagePassPhone,
  turnOffCardHolder,
} from "@/api/cardHolder/index";
import dayjs from "dayjs";
import { downloadXls, dateNow } from "@/utils/util.js";

export default {
  name: "Cards",
  data() {
    return {
      // 查询参数
      queryParams: {
        companyName: "",
        userName: "",
        Phone: "",
        page: 1,
        pageSize: 10,
      },
      // 表格数据
      cardList: [],
      // 加载中
      loading: false,
      // 分页信息
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      // 弹窗可见性
      dialogVisible: false,
      // 弹窗标题
      dialogTitle: "新增工会卡",
      // 表单数据
      formData: {},
      // 表单校验规则
      formRules: {
        unitName: [
          { required: true, message: "请输入单位名称", trigger: "blur" },
        ],
        personCount: [
          { required: true, message: "请输入人数", trigger: "blur" },
        ],
        startTime: [
          { required: true, message: "请选择开始时间", trigger: "blur" },
        ],
        endTime: [
          { required: true, message: "请选择结束时间", trigger: "blur" },
        ],
        amount: [{ required: true, message: "请输入金额", trigger: "blur" }],
      },
      // 提交按钮加载状态
      submitLoading: false,
      // 导入弹窗可见性
      importDialogVisible: false,
      // 导入文件列表
      fileList: [],
      // 导入按钮加载状态
      importLoading: false,
    };
  },
  created() {
    this.getCardList();
  },
  methods: {
    exportExcel() {
      let params = {
        companyName: this.queryParams.companyName,
        userName: this.queryParams.userName,
        Phone: this.queryParams.Phone,
      };
      PostExportCardHolderExcel(params)
        .then((res) => {
          if (res && res.data) {
            downloadXls(res.data, `工会卡列表${dateNow()}.xlsx`);
          } else {
            console.error("导出失败，未获取到数据");
          }
        })
        .catch((error) => {
          console.error("导出失败", error);
        });
    },
    exportTemplate() {
      window.open(
        "https://zheliyundong.scqtkj.com/file/Template.xlsx",
        "_blank",
      );
    },
    // 获取默认开始时间（当前时间）
    getDefaultStartTime() {
      return dayjs().format("YYYY-MM-DD HH:mm:ss");
    },

    // 获取默认结束时间（当前时间 + 1年）
    getDefaultEndTime() {
      return dayjs().add(1, "year").format("YYYY-MM-DD HH:mm:ss");
    },

    // 格式化日期时间显示
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return "";
      return dayjs(dateTimeStr).format("YYYY-MM-DD");
    },

    // 获取卡片列表
    getCardList() {
      this.loading = true;
      GetUnionCardList({
        companyName: this.queryParams.companyName,
        userName: this.queryParams.userName,
        Phone: this.queryParams.Phone,
        page: this.pagination.page,
        intPageSize: this.pagination.pageSize,
      })
        .then((response) => {
          console.log(response);
          if (response.data.success) {
            this.cardList = response.data.response.data;
            this.pagination.total = response.data.response.dataCount;
          } else {
            this.$message.error(response.data.message || "获取卡片列表失败");
          }
        })
        .catch((error) => {
          console.error("获取卡片列表出错:", error);
          this.$message.error("获取卡片列表出错");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 查询按钮点击事件
    handleQuery() {
      this.pagination.page = 1;
      this.getCardList();
    },

    // 重置查询条件
    resetQuery() {
      this.queryParams = {
        unitName: "",
        name: "",
        page: 1,
        pageSize: 10,
      };
      this.getCardList();
    },

    // 分页大小变更事件
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.getCardList();
    },

    // 分页页码变更事件
    handleCurrentChange(val) {
      this.pagination.page = val;
      this.getCardList();
    },

    // 新增按钮点击事件
    handleAdd() {
      this.dialogTitle = "新增工会卡";
      this.formData = {
        unitName: "",
        personCount: 1,
        startTime: this.getDefaultStartTime(),
        endTime: this.getDefaultEndTime(),
        amount: 0,
      };
      this.dialogVisible = true;
    },

    // 提交表单
    submitForm() {
      this.$refs.cardForm.validate((valid) => {
        if (valid) {
          this.submitLoading = true;

          // 构建提交参数
          const params = {
            CompanyName: this.formData.unitName,
            Count: this.formData.personCount,
            StartTime: this.formData.startTime,
            EndTime: this.formData.endTime,
            SumPrice: this.formData.amount,
          };

          PostBatchBuildCard(params)
            .then((response) => {
              if (response.data.success) {
                this.$message.success("新增工会卡成功");
                this.dialogVisible = false;
                this.getCardList();
              } else {
                this.$message.error(response.data.message || "新增工会卡失败");
              }
            })
            .catch((error) => {
              console.error("新增工会卡出错:", error);
              this.$message.error("新增工会卡出错");
            })
            .finally(() => {
              this.submitLoading = false;
            });
        } else {
          return false;
        }
      });
    },

    // 导入Excel按钮点击事件
    importTemplateExcel() {
      this.importDialogVisible = true;
      this.fileList = [];
    },

    // 文件选择变更事件
    handleFileChange(file, fileList) {
      this.fileList = fileList;
    },

    // 文件移除事件
    handleFileRemove(file, fileList) {
      this.fileList = fileList;
    },

    // 上传前验证
    beforeUpload(file) {
      const isExcel =
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
        file.type === "application/vnd.ms-excel";
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isExcel) {
        this.$message.error("只能上传Excel文件!");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("文件大小不能超过10MB!");
        return false;
      }
      return true;
    },

    // 提交导入
    submitImport() {
      if (this.fileList.length === 0) {
        this.$message.warning("请先选择要上传的Excel文件");
        return;
      }

      this.importLoading = true;
      const formData = new FormData();
      formData.append("file", this.fileList[0].raw);

      PostImportCardHolderExcel(formData)
        .then((response) => {
          if (response.data.success) {
            this.$message.success("导入成功");
            this.importDialogVisible = false;
            this.getCardList(); // 刷新列表
          } else {
            this.$message.error(response.data.message || "导入失败");
          }
        })
        .catch((error) => {
          console.error("导入出错:", error);
          this.$message.error("导入出错");
        })
        .finally(() => {
          this.importLoading = false;
        });
    },
    // 删除按钮点击事件
    handleDel(row) {
      this.$confirm("确认删除该工会卡吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          DeleteCardHolder({ ids: [row.Id] })
            .then((response) => {
              if (response.data.success) {
                this.$message.success("删除成功");
                this.getCardList(); // 刷新列表
              } else {
                this.$message.error(response.data.message || "删除失败");
              }
            })
            .catch((error) => {
              console.error("删除出错:", error);
              this.$message.error("删除出错");
            });
        })
        .catch(() => {
          this.$message.info("已取消删除");
        });
    },

    handleTurnOff(row) {
      this.$confirm("确认停用该工会卡吗？", "提示", {
        confirmButtonText: "停用",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          turnOffCardHolder(row.Id)
            .then((response) => {
              if (response.data.success) {
                this.$message.success("停用成功");
                this.getCardList(); // 刷新列表
              } else {
                this.$message.error(response.data.message || "停用失败");
              }
            })
            .catch((error) => {
              console.error("停用出错:", error);
              this.$message.error("停用出错");
            });
        })
        .catch(() => {
          this.$message.info("已取消操作");
        });
    },

    // 发送短信兑换提醒
    sendToSmsMsg(row) {
      this.$confirm(
        `确认向 ${row.UserName}(${row.TelPhone}) 发送兑换提醒短信吗？`,
        "兑换提醒",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "info",
        },
      )
        .then(() => {
          GetSendMessagePassPhone({ id: row.Id }).then((response) => {
            if (response.data.success) {
              this.$message.success("发送成功");
            } else {
              this.$message.error(response.data.msg || "发送失败");
            }
          });
        })
        .catch(() => {
          this.$message.info("已取消发送");
        });
    },

    // 导出工会卡剩余情况信息列表
    exportCardHolderRealExcel() {
      let params = {
        CompanyName: this.queryParams.companyName,
        UserName: this.queryParams.userName,
        TelPhone: this.queryParams.Phone,
      };
      PostExportCardHolderRealExcel(params)
        .then((response) => {
          if (response.data) {
            downloadXls(
              response.data,
              `工会卡剩余情况信息列表${dateNow()}.xlsx`,
            );
            this.$message.success("导出成功");
          }
        })
        .catch((error) => {
          console.error("导出出错:", error);
          this.$message.error("导出出错");
        });
    },
  },
};
</script>

<style scoped>
.mt20 {
  margin-top: 20px;
}

.el-pagination {
  text-align: right;
  margin-top: 20px;
}

.form-container .el-form-item {
  margin-bottom: 22px;
}

.form-input {
  width: 100%;
}

/* 覆盖el-input-number的默认宽度 */
.el-input-number.form-input {
  width: 100%;
}

/* 覆盖日期选择器的默认宽度 */
.el-date-editor.form-input {
  width: 100% !important;
}

/* 表单标签两端对齐 */
.form-container /deep/ .el-form-item__label {
  text-align: justify;
  text-align-last: justify; /* 最后一行也对齐 */
  text-justify: inter-ideograph; /* 增强对中文的支持 */
  width: 100px; /* 确保宽度固定，与label-width一致 */
  padding-right: 12px; /* 给右侧留一些空间 */
}

/* 确保卡片宽度为容器的100% */
.app-container .box-card {
  width: 100%;
  box-sizing: border-box;
}

/* 上传组件样式 */
.upload-container {
  text-align: center;
  padding: 20px;
}

.upload-demo .el-upload {
  width: 100%;
}

.upload-demo .el-upload-dragger {
  width: 100%;
}

.el-upload__tip {
  color: #909399;
  margin-top: 10px;
}
</style>
